import React from 'react';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import NumericInput from './FilterComponents/CoreComponents/NumericInput';
import UtrFilterComponent from './FilterComponents/UtrFilterComponent';
import DateFilter from './FilterComponents/DateFilter';

import styles from '../search.scss';

const DivisionsMoreMobileFilter = (props) => {
    const { isActive, commonFilterProps, mobileOnly, desktopOnly, hasDivisionDate, defaultFilterValues, 'data-testid': dataTestId } = props;
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterUpdate, handleFilterSubmit } = commonFilterProps;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'divisionsMoreMobile'}
                handleFilterClick={handleFilterClick}
                isActive={isActive || filterModal === 'divisionsMoreMobile'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                More...
            </Filter>
            {filterModal === 'divisionsMoreMobile' && (
                <FilterModal
                    title={'More...'}
                    onCloseClick={closeModals}
                    scrollable={true}
                    handleFilterSubmit={handleFilterSubmit}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <div className={styles.searchFilterModalDiv} />
                        <>
                            <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.age-title`}>Your Age</div>
                            <NumericInput
                                value={filterInputs.age || ''}
                                onChange={(age) => {
                                    handleFilterUpdate({ age });
                                }}
                                data-testid={dataTestId && `${dataTestId}.age-input`}
                            />
                            <div className={styles.searchFilterModalDiv} />

                            <UtrFilterComponent
                                filterInputs={filterInputs}
                                isHalfSteps={true}
                                handleUTRChange={(range) => {
                                    handleFilterUpdate({
                                        utrMin: range[0],
                                        utrMax: range[1],
                                    });
                                }}
                                showExpandedUtrFilter={false}
                                handleUtrTypeClick={(utrType) => {
                                    handleFilterUpdate({ utrType });
                                }}
                                handleUtrTeamTypeClick={(utrTeamType) => {
                                    handleFilterUpdate({ utrTeamType });
                                }}
                                handleUtrReliabilityClick={(utrReliability) => {
                                    handleFilterUpdate({ utrReliability });
                                }}
                                filters={filters}
                                isMemberFilter={false}
                                data-testid={dataTestId && `${dataTestId}.utr-filter`}
                            />
                            {hasDivisionDate && (
                                <>
                                    <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.date-title`}>Date</div>
                                    <DateFilter
                                        customDateSelectOptions={[]}
                                        startDate={filterInputs.startDate}
                                        endDate={filterInputs.endDate}
                                        fromDateChange={(momentObj) => { handleFilterUpdate({ startDate: momentObj }); }}
                                        toDateChange={(momentObj) => {
                                            handleFilterUpdate({ endDate: momentObj });
                                        }}
                                        handleFilterUpdate={handleFilterUpdate}
                                        minDate={defaultFilterValues.startDate}
                                        maxDate={defaultFilterValues.endDate}
                                        onlyCustom
                                        data-testid={dataTestId && `${dataTestId}.date-filter`}
                                    />
                                </>
                            )}
                        </>
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

DivisionsMoreMobileFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    commonFilterProps: PropTypes.objectOf(any).isRequired,
    defaultFilterValues: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    isActive: PropTypes.bool,
    hasDivisionDate: PropTypes.bool,
    'data-testid': PropTypes.string,
};
DivisionsMoreMobileFilter.defaultProps = {
    handleFilterClick: () => { },
    handleFilterSubmit: () => { },
    closeModals: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    isActive: false,
    hasDivisionDate: false,
    'data-testid': undefined,
};

export default DivisionsMoreMobileFilter;
